import { Location as HistoryLocation } from 'history'
import size from 'lodash/size'
import { regExpsRaw } from 'src/constants/RegExpsRaw'
import { TSnses } from 'src/modules/entity/API'
import { existObject } from 'src/util/object'

/**
 * 以下のページのハッシュ値を抜き出します。
 *
 * 詳細ページ /brand/:brandId/account/:mId/provider/:provider/post/:postId
 * アカウント一覧ページ /brand/:brandId/accounts
 *
 * return 各hash要素のオブジェクト
 *
 * @param {string} locationPathName
 */
export type GetUriQueriesFromLocation = {
  brandId: string
  mId?: string
  provider?: TSnses
  postId?: string
  accountSegment?: string
}
export const getUriQueriesFromLocation = (locationPathName: string): GetUriQueriesFromLocation => {
  // $1: brandId, $2: mId, $3: provider, $4: postId
  const dashboardMatch = locationPathName.match(new RegExp(regExpsRaw.dashboardPath))
  const accountPostMatch = locationPathName.match(new RegExp(regExpsRaw.accountPostPagePath))
  const accountMatch = locationPathName.match(new RegExp(regExpsRaw.accountPagePath))
  const accountListMatch = locationPathName.match(new RegExp(regExpsRaw.accountListPagePath))
  const campaignMatch = locationPathName.match(new RegExp(regExpsRaw.campaignPath))
  if (existObject(accountPostMatch)) {
    return {
      brandId: accountPostMatch[1],
      mId: accountPostMatch[2],
      provider: accountPostMatch[3] as TSnses,
      postId: accountPostMatch[4],
      accountSegment: 'post'
    }
  }
  if (existObject(accountMatch)) {
    return {
      brandId: accountMatch[1],
      mId: accountMatch[2],
      provider: accountMatch[3] as TSnses,
      accountSegment: accountMatch[4]
    }
  }
  if (existObject(accountListMatch)) {
    return { brandId: accountListMatch[1] }
  }
  if (existObject(campaignMatch)) {
    return { brandId: campaignMatch[1] }
  }
  if (existObject(dashboardMatch)) {
    return { brandId: dashboardMatch[1] }
  }
  return { brandId: '', mId: '', provider: '', postId: '' }
}

/**
 * redirect クエリから decodeUri された以下部分を抜き出す
 * 形式: /brand/:brandId/account/:mId/provider/:provider/post/:postId
 *
 * @param {any | HistoryLocation} location
 */
export const getDecodedRedirectUri = (location: any | HistoryLocation): string => {
  const target = 'href' in location ? location.href : location.search
  if (new RegExp(regExpsRaw.redirect + '.+').test(target)) {
    return decodeURIComponent(target)
      .replace(new RegExp(regExpsRaw.redirect), '')
      .replace(new RegExp(regExpsRaw.domainAt$1), '')
  } else {
    return ''
  }
}

/**
 * twitter の url を slice する
 * ドメイン後のスラッシュ(含む)から数えて15文字で truncate される
 *
 * FIXME ハッシュタグも truncate される
 * @param provider
 * @param url
 * @param urlMaxLength
 */
export const sliceUrl = (provider: TSnses, url: string, urlMaxLength: number) => {
  if (provider === 'twitter') {
    const urlFromDomain = url.replace(new RegExp(regExpsRaw.tillProtocol), '')
    const domainAt$1 = url.match(new RegExp(regExpsRaw.domainAt$1))
    return (
      domainAt$1[1] +
      urlFromDomain.substr(size(domainAt$1[1]), urlMaxLength) +
      (size(urlFromDomain) > urlMaxLength ? '...' : '')
    )
  } else {
    return url
  }
}
